export const SECTION_NAME_FOR_ADS = {
  home: 'home',
  registration: 'registracion',
  schoolRegistration: 'registracion/escuela',
  nameRegistration: 'registracion/nombredeequipo',
  faqs: 'preguntasfrecuentes',
  welcome: 'welcome',
  datosPersonales: 'datospersonales',
  ayudante: 'ayudante',
  copadeamigos: 'copadeamigos',
  desafio1a1: 'desafio1a1',
  fechadeoro: 'fechadeoro',
  armadoFutbol5: 'armadofutbol5',
  futbol5: 'futbol5',
  login: 'login',
  medallero: 'medallero',
  mispines: 'mispines',
  miequipo: 'miequipo',
  armadoMiEquipo: 'armadomiequipo',
  miniligas: 'miniligas',
  rankings: 'rankings',
  torneodeescuelas: 'torneodeescuelas',
  escuelasecundaria: 'torneodeescuelas/secundaria',
  escuelaprimaria: 'torneodeescuelas/primaria',
  torneodeamigospremios: 'torneodeamigos/torneodeamigosporpremios',
  torneodeamigos: 'torneodeamigos',
  torneovip: 'torneodeamigos/torneodeamigosvip',
};

export const ADS_DIV_ID = {
  horizontal: 'div-gpt-ad-horizontal1',
  caja1: 'div-gpt-ad-caja1',
  caja2: 'div-gpt-ad-caja2',
  caja3: 'div-gpt-ad-caja3',
};
